import { convertToAddOnService } from '@spike/addon-services-action';
import { convertToAppointment } from '@spike/bookings-action';
import { convertToClient } from '@spike/clients-action';
import { OrderizableTypes, RedeemTypes } from '@spike/order-model';
import { convertToPet } from '@spike/pets-action';
import { convertToProduct } from '@spike/products-action';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
export var convertToOrder = function (orderResponseDto, masterData, marketplace, timeZone) { return ({
    id: orderResponseDto.order.id,
    uuid: orderResponseDto.order.uuid,
    client: convertToClient(masterData, timeZone, orderResponseDto.customer, false),
    shipToClient: convertToClient(masterData, timeZone, orderResponseDto.ship_to_customer, false),
    notes: orderResponseDto.order.notes === null ? '' : orderResponseDto.order.notes,
    issuedAt: moment(orderResponseDto.order.issued_at).tz(timeZone),
    createdAt: moment(orderResponseDto.order.created_at).tz(timeZone),
    updatedAt: moment(orderResponseDto.order.updated_at).tz(timeZone),
    items: convertToOrderItems(orderResponseDto, masterData, marketplace, timeZone),
    version: isEmpty(orderResponseDto.order.version) ? '' : orderResponseDto.order.version,
    invoiceId: orderResponseDto.order.invoice_id ? orderResponseDto.order.invoice_id : undefined,
    total: orderResponseDto.order.total,
    paid: orderResponseDto.order.paid,
}); };
var convertToOrderItems = function (orderResponseDto, masterData, marketplace, timeZone) {
    var items = orderResponseDto.order.order_items.map(function (orderItemDto) { return convertToOrderItem(orderItemDto, timeZone); });
    var appointments = orderResponseDto.appointments.map(function (appointmentDto) { return convertToAppointment(appointmentDto, masterData, timeZone); });
    var products = orderResponseDto.products.map(function (orderProductDto) { return convertToProduct(orderProductDto.product, masterData, marketplace); });
    var addOnServices = orderResponseDto.add_ons.map(function (addOnDto) { return convertToAddOnService(addOnDto); });
    var pets = orderResponseDto.pets.map(function (petDto) { return convertToPet(masterData, marketplace, timeZone, petDto); });
    var staff = orderResponseDto.staff.map(function (staffDto) { return ({
        id: staffDto.id,
        firstName: staffDto.first_name,
        lastName: staffDto.last_name,
        avatar: staffDto.image
    }); });
    var appointmentItems = items.filter(function (item) { return item.orderizable.type === OrderizableTypes.APPOINTMENT; }).map(function (item) {
        var appointment = appointments.find(function (appointment) { return appointment.id === item.orderizable.id; });
        var pet = pets.find(function (pet) { return pet.id === appointment.pet.id; });
        return {
            orderItem: item,
            appointment: appointment,
            pet: pet
        };
    });
    var productItems = items.filter(function (item) { return item.orderizable.type === OrderizableTypes.PRODUCT; }).map(function (item) { return ({
        orderItem: item,
        product: products.find(function (product) { var _a, _b; return ((_b = (_a = product.businessProduct) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : product.id) === item.orderizable.id; }),
        pet: pets.find(function (pet) { return pet.id === item.petId; }),
        staff: staff.find(function (staff) { return staff.id === item.staffId; }),
    }); });
    var addOnServiceItems = items.filter(function (item) { return item.orderizable.type === OrderizableTypes.ADDON_SERVICE; }).map(function (item) { return ({
        orderItem: item,
        addOnService: addOnServices.find(function (addOnService) { return addOnService.id === item.orderizable.id; }),
        pet: pets.find(function (pet) { return pet.id === item.petId; }),
        staff: staff.find(function (staff) { return staff.id === item.staffId; }),
    }); });
    var customItems = items.filter(function (item) { return item.orderizable.type === OrderizableTypes.CUSTOM; }).map(function (item) { return ({
        orderItem: item,
        pet: pets.find(function (pet) { return pet.id === item.petId; }),
        staff: staff.find(function (staff) { return staff.id === item.staffId; }),
    }); });
    var membershipsItems = items.filter(function (item) { return item.orderizable.type === OrderizableTypes.MEMBERSHIP; }).map(function (item) { return ({
        orderItem: item,
    }); });
    return {
        appointments: appointmentItems.sort(appointmentOrderItemComparator),
        products: productItems.sort(function (productOrderItem, otherProductOrderItem) { return orderItemComparator(productOrderItem.orderItem, otherProductOrderItem.orderItem); }),
        addOnServices: addOnServiceItems.sort(function (addOnServiceOrderItem, otherAddOnServiceOrderItem) { return orderItemComparator(addOnServiceOrderItem.orderItem, otherAddOnServiceOrderItem.orderItem); }),
        customs: customItems.sort(function (customOrderItem, otherCustomOrderItem) { return orderItemComparator(customOrderItem.orderItem, otherCustomOrderItem.orderItem); }),
        memberships: membershipsItems
    };
};
var convertToOrderItem = function (orderItemDto, timeZone) { return ({
    id: orderItemDto.id,
    uuid: orderItemDto.uuid,
    orderId: orderItemDto.order_id,
    orderizable: convertToOrderizable(orderItemDto),
    petId: orderItemDto.pet_id === null ? undefined : orderItemDto.pet_id,
    staffId: orderItemDto.staff_id === null ? undefined : orderItemDto.staff_id,
    description: orderItemDto.description,
    quantity: orderItemDto.quantity,
    amount: orderItemDto.amount,
    discount: orderItemDto.discount_amount === null && orderItemDto.discount_percentage === null ? undefined : {
        amount: orderItemDto.discount_amount === null ? undefined : orderItemDto.discount_amount,
        percentage: orderItemDto.discount_percentage === null ? undefined : orderItemDto.discount_percentage,
    },
    total: orderItemDto.total,
    originalPrice: orderItemDto.original_price,
    startedAt: orderItemDto.started_at ? moment(orderItemDto.started_at).tz(timeZone) : undefined,
    createdAt: moment(orderItemDto.created_at).tz(timeZone),
    updatedAt: moment(orderItemDto.updated_at).tz(timeZone),
    taxId: orderItemDto.tax_id === null ? undefined : orderItemDto.tax_id,
    redeem: convertToRedeem(orderItemDto, timeZone),
}); };
var appointmentOrderItemComparator = function (appointmentItem, otherAppointmentItem) {
    return appointmentItem.appointment.duration.from.clone().diff(otherAppointmentItem.appointment.duration.to.clone());
};
var orderItemComparator = function (orderItem, otherOrderItem) {
    var _a, _b;
    if (orderItem.startedAt === undefined && otherOrderItem.startedAt === undefined) {
        return ((_a = orderItem.id) !== null && _a !== void 0 ? _a : 0) - ((_b = otherOrderItem.id) !== null && _b !== void 0 ? _b : 0);
    }
    else if (orderItem.startedAt !== undefined && otherOrderItem.startedAt === undefined) {
        return 1;
    }
    else if (orderItem.startedAt === undefined && otherOrderItem.startedAt !== undefined) {
        return -1;
    }
    else {
        return orderItem.startedAt.clone().diff(otherOrderItem.startedAt.clone());
    }
};
var convertToOrderizable = function (orderItemDto) { return ({
    type: convertToOrderType(orderItemDto.orderizable_type),
    id: orderItemDto.orderizable_id,
}); };
var convertToOrderType = function (orderTypeDto) {
    switch (orderTypeDto === null || orderTypeDto === void 0 ? void 0 : orderTypeDto.toLocaleLowerCase()) {
        case 'appointment':
            return OrderizableTypes.APPOINTMENT;
        case 'businessproduct':
            return OrderizableTypes.PRODUCT;
        case 'addonservice':
            return OrderizableTypes.ADDON_SERVICE;
        case 'membership':
            return OrderizableTypes.MEMBERSHIP;
        default:
            return OrderizableTypes.CUSTOM;
    }
};
var convertToOrderizableTypeRequest = function (orderItem) {
    switch (orderItem.orderizable.type) {
        case OrderizableTypes.APPOINTMENT:
            return "Appointment";
        case OrderizableTypes.PRODUCT:
            return "BusinessProduct";
        case OrderizableTypes.ADDON_SERVICE:
            return "AddonService";
        case OrderizableTypes.MEMBERSHIP:
            return "Membership";
        default:
            return null;
    }
};
var convertToRedeem = function (orderItemDto, timeZone) {
    if (orderItemDto.redeem_id && orderItemDto.redeem_type) {
        var type = convertToRedeemType(orderItemDto.redeem_type);
        return type ? {
            type: type,
            id: orderItemDto.redeem_id,
            membership: orderItemDto.redeem_name && orderItemDto.redeem_membership_created_at ? {
                name: orderItemDto.redeem_name,
                createdAt: moment(orderItemDto.redeem_membership_created_at).tz(timeZone),
            } : undefined
        } : undefined;
    }
    else {
        return undefined;
    }
};
var convertToRedeemTypeRequest = function (redeem) {
    switch (redeem === null || redeem === void 0 ? void 0 : redeem.type) {
        case RedeemTypes.ENROLLMENT:
            return "Enrollment";
        default:
            return null;
    }
};
var convertToRedeemType = function (redeemTypeDto) {
    switch (redeemTypeDto === null || redeemTypeDto === void 0 ? void 0 : redeemTypeDto.toLocaleLowerCase()) {
        case 'enrollment':
            return RedeemTypes.ENROLLMENT;
        default:
            return undefined;
    }
};
export var convertToOrderRedeemsRequest = function (orderId, orderItemRedeems, marketplaceId) { return ({
    id: orderId,
    marketplace_id: marketplaceId,
    order_items_attributes: orderItemRedeems.map(function (item) { return convertToOrderItemRedeemRequest(orderId, item, marketplaceId); })
}); };
export var convertToOrderItemRedeemRequest = function (orderId, orderItemRedeem, marketplaceId) {
    var _a, _b;
    return ({
        id: orderItemRedeem.orderItemId,
        order_id: orderId,
        marketplace_id: marketplaceId,
        redeem_type: convertToRedeemTypeRequest(orderItemRedeem.redeem),
        redeem_id: (_b = (_a = orderItemRedeem.redeem) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null,
    });
};
export var convertToOrderRequest = function (order, marketplaceId) { return ({
    id: order.id,
    uuid: order.uuid,
    marketplace_id: marketplaceId,
    notes: order.notes,
    customer_id: order.clientId,
    ship_to_customer_id: order.shipToClientId,
    issued_at: order.issuedAt ? formatToDateRequest(order.issuedAt) : undefined,
    order_items_attributes: order.items.map(function (item) { return convertToOrderItemRequest(item, marketplaceId); })
}); };
export var convertToNotesRequest = function (notes) { return ({
    notes: notes,
}); };
export var convertToOrderItemRequest = function (orderItem, marketplaceId, orderId) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    return ({
        id: orderItem.id,
        uuid: orderItem.uuid,
        order_id: orderId,
        marketplace_id: marketplaceId,
        amount: orderItem.amount,
        description: orderItem.description,
        discount_amount: ((_a = orderItem.discount) === null || _a === void 0 ? void 0 : _a.amount) === undefined || ((_b = orderItem.discount) === null || _b === void 0 ? void 0 : _b.percentage) !== undefined ? null : (_c = orderItem.discount) === null || _c === void 0 ? void 0 : _c.amount,
        discount_percentage: ((_d = orderItem.discount) === null || _d === void 0 ? void 0 : _d.percentage) ? (_e = orderItem.discount) === null || _e === void 0 ? void 0 : _e.percentage.toString() : null,
        orderizable_type: convertToOrderizableTypeRequest(orderItem),
        orderizable_id: ((_f = orderItem.orderizable) === null || _f === void 0 ? void 0 : _f.id) ? (_g = orderItem.orderizable) === null || _g === void 0 ? void 0 : _g.id : null,
        quantity: orderItem.quantity,
        pet_id: orderItem.petId ? orderItem.petId : null,
        staff_id: orderItem.staffId ? orderItem.staffId : null,
        started_at: orderItem.startedAt ? formatToDateRequest(orderItem.startedAt) : null,
        tax_id: orderItem.taxId ? orderItem.taxId : null,
        redeem_type: (_j = (_h = orderItem.redeem) === null || _h === void 0 ? void 0 : _h.type) !== null && _j !== void 0 ? _j : null,
        redeem_id: (_l = (_k = orderItem.redeem) === null || _k === void 0 ? void 0 : _k.id) !== null && _l !== void 0 ? _l : null,
    });
};
var formatToDateRequest = function (date) { return date.clone().utc().format('YYYY-MM-DDTHH:mm:ss.SSSz').replace('UTC', 'Z'); };
